import { Injectable } from '@angular/core';
import { TooltipData } from '../models/TooltipData';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private tooltipMap = [];

  constructor() {
    TooltipData.forEach(tooltip => {
      this.tooltipMap[tooltip.key] = tooltip.value;
    });
  }

  getItems() {
    return Promise.resolve(TooltipData);
  }

  getMap() {
    return this.tooltipMap;
  }

  getTooltipValue(key: string) {
    return this.tooltipMap[key];
  }

  getTooltip(key: string) {
    return this.getItems().then(
      alldata => alldata.filter(data => data.key === key)[0]
    );
  }
}
